import { type BoxProps } from "@mui/material"
import { type MouseEvent } from "react"

import { type SelectItem } from "@/utils/dataTypes"
import BigNumber from "bignumber.js"

export type TokenPickerType = "primary" | "secondary"

export type TokenPickerProps = {
  "data-testid"?: string
  nickName: string
  disableDropdown?: boolean
  boxProps?: BoxProps
  allowCustomMintAddress?: boolean
  selectedToken?: SelectItem
  setSelectedToken?: (token: SelectItem) => void
  blackList?: string[]
  tokens?: SelectItem[] | ((keyword: string, page: number) => Promise<SelectItem[]>)
  filterToken?: (t: SelectItem) => boolean
  isShowSearch?: boolean
  variant?: TokenPickerType
  isDisplayAddress?: boolean
  isDisplayIcon?: boolean
  emptySelectionText?: string
  isShowDialog?: boolean
  recentTokens?: string[]
}

export type TokenPickerViewProps = {
  boxProps?: BoxProps
  "data-testid"?: string
  handleClick: (event: MouseEvent<HTMLElement>) => void
  hasDropdown: boolean
  token?: SelectItem
  isDisplayIcon?: boolean
  emptySelectionText?: string
}

export const DefaultTokenInfo: SelectItem = {
  value: "Unknown",
  icon: "https://icotar.com/initials/Not%20Available.svg",
  iconName: "logo",
  alt: "logo",
  price: new BigNumber(1),
  ltv: 10,
  symbol: "",
}
